import { Box } from '@ace-clublabs/shared-component-library';
import { NewJoinConfirmationData } from '@lib/types';
import { StatelessConfirmationCard, StatelessConfirmationItemDetails } from './StatelessConfirmationCard';

export const StatelessPaymentDetails = (confirmation: NewJoinConfirmationData) => {
  const { paymentDetails, amount, autoPayStatus } = confirmation!;
  const { card } = paymentDetails!;
  const { brand, last4 } = card || {};

  const getIconForCard = (cardBrand: string) => {
    switch (cardBrand?.toLowerCase()) {
      case 'visa':
        return 'visa-logo';
      case 'american-express':
      case 'americanexpress':
      case 'amex':
        return 'amex-logo';
      case 'dinersclub':
      case 'discover':
        return 'discover-logo';
      case 'jcb':
        return 'jcb-logo';
      case 'unionpay':
        return 'union-pay-logo';
      case 'maestro':
      case 'mastercard':
        return 'mastercard-logo';
      default:
        return null;
    }
  };

  const getPaymentDetailItems = () => {
    const paymentDetailsItems: StatelessConfirmationItemDetails[] = [
      {
        title: 'Amount paid today:',
        details: `$${amount}`,
        className: 'amount-paid',
      },
    ];

    paymentDetailsItems.push({
      title: 'Payment method:',
      details: 'Card',
      cardLastFour: last4,
      iconName: getIconForCard(brand!),
      className: 'payment-method',
    });
    
    paymentDetailsItems.push({
      autoPayEnrolled: autoPayStatus === 'succeeded' ? true : false,
      className: 'autopay-enrolled-status',
    });

    return paymentDetailsItems;
  };

  return (
    <Box className="payment-details-container">
      <StatelessConfirmationCard cardTitle="Payment details" items={getPaymentDetailItems()} />
    </Box>
  );
};
